<template>
  <div class="color-f5f5f5">
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="open-header">
      <img class="open-bg" src="../../assets/image/icon_service_header.png"></img>
      <div class="open-box">
        <div class="open-header-box">
          <span class="open-header-day">{{dayText}}</span>
          <span class="open-header-day open-header-label">今日开服</span>
          <span class="open-header-count">{{serviceTotal}}</span>
        </div>
      </div>
    </div>
    <div class="open-service-body">
      <div class="label-item">
        <span>设备：</span>
        <ul class="label-select-ul">
          <li class="label-select-li" :class="gameTypeDirector === index ?
              'label-select-active-li':''" v-for="(item, index) in deviceList" :key="index"
            @click="gameTypeSelect(index)"> {{ item.title }}
          </li>
        </ul>
      </div>
      <div class="label-item">
        <span>标签：</span>
        <ul class="label-select-ul">   
          <li class="label-two-select-li" v-for="(item,index) in gameLabelList" :key="index" @click="gameLabelSelect(item.id)"
            :class="gameLabelDirector === item.id ? 'label-two-select-active-li':''">{{item.text}}</li>
        </ul>
      </div>
      <div class="label-item" style="margin-bottom: 15px;">
        <span>字母：</span>
        <ul class="label-select-ul">
          <li class="label-two-select-li" :class="gameLetterDirector === index ? 'label-two-select-active-li':''"
            v-for="(item, index) in letterList" :key="index"
            @click="gameLetterSelect(index)">
            {{ item.title }}
          </li>
        </ul>
      </div>
      <ul class="time-tab-ul">
        <li class="time-tab-li" :class="timeDirector===index?'time-tab-li-active':''" 
        v-for="(item, index) in timeList" :key="index" @click="timeSelect(index,item.timeText)">
          <span :class="timeDirector===index?'time-tab-li-span-active time-tab-li-span':'time-tab-li-span'">
          {{item.dateText}}</span>
        </li>
        <div class="time-tab-search">
          <input class="time-tab-input" placeholder="快速搜索游戏名称和区服" v-model="serviceBean.search"
          v-on:input="searchGameEvent">
          <i class="icon-top time-tab-i" @click="searchGameEvent"></i>
        </div>
      </ul>   
      <div class="service-right-item" v-for="(item,index) in serviceList" :key="index" >
        <img class="service-image" :src="baseImageAddress + 'type=small&game_tag=' + item.game_tag"
         @click="enterOfficial(item.game_tag,item.game_device);">
        <div class="service-name" @click="enterOfficial(item.game_tag,item.game_device);">
          <span>{{item.game_name}}</span>
          <span>{{item.game_type_name}}</span>
        </div>
        <span class="service-red">{{new Date(item.game_time).Format("MM-dd hh:mm")}}</span> 
        <span class="service-right-table">{{item.game_area_name}}</span>
        <span class="service-red">1={{item.game_ratio}}{{item.game_coin_name}}</span>
        <div class="service-operate">
          <span style="float: left;margin-right: 10px;" class="service-bottom" v-if="item.game_gift_state == 1" 
          @click="enterGift(item.game_name)">领取礼包</span> 
          <span style="float: right;" class="service-bottom" @click="enterOfficial(item.game_tag,item.game_device)">官网</span>        
        </div>
      </div>   
      <img class="service-empty-img" src="../../assets/image/open_service_empty_normal.jpg" v-show="showEmptyState">
      <div class="page-div" style="margin-top: 30px;" v-show="!showEmptyState">
        <CommonPage class="center-game-page" :current.sync='serviceBean.page' 
          :page-size="serviceBean.row" :total="serviceTotal" show-total prev-text="上一页"  @on-change="selectPage" next-text="下一页" />
      </div>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
    @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
    @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
  import Footer from '../../components/common/Footer';
  import Header from '../../components/common/Header';
  import SuspendSide from '../../components/SuspendSide';
  import SuspendMember from '../../components/SuspendMember';
  import CommonPage from '../../components/CommonPage';
  export default {
    metaInfo(){
      return {
        title:"开服表大厅_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    components: {
      Footer, Header, SuspendSide,SuspendMember, CommonPage
    },
    computed:{
      gameLabelList(){
        return this.$store.state.openTable.gameLabelList;
      },
      serviceList:{
        get(){
          return this.$store.state.openTable.serviceList;
        },set(value){
          this.$store.state.openTable.serviceList = value;
        }   
      },
      tempServiceList:{
        get(){
          return this.$store.state.openTable.tempServiceList;
        },set(value){
          this.$store.state.openTable.tempServiceList = value;
        }
      },
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      serviceTotal:{
        get(){
          return this.$store.state.openTable.serviceTotal;
        },set(value){
          this.$store.state.openTable.serviceTotal = value;
        }
      },
      deviceList(){
        return this.$store.state.constant.deviceList;
      },
      letterList(){
        return this.$store.state.constant.letterList;
      }
    },
    asyncData({store,route}){
      return store.dispatch('initOpenTable',{store:store});
    },
    data() {
      return {
        loginState:false,
        oldTimeStamp:0,
        oldSearchName:"",
        serviceBean:{
          type:0,
          classify:0,
          letter:0,
          time:0,
          endTime:0,
          search:"",
          page:1,
          row: 30
        },
        gameLabelDirector:0,
        gameTypeDirector: 0,
        gameLetterDirector: 0,
        timeProgressDirector: 0,
        timeDirector:0,
        dayText:"",
        timeList:[],
        timeTempList:[],
        suspendState:false,
        suspendType:0,
        showEmptyState:false,
      };
    },
    mounted(){
      this.initTab();
      if(window.sessionStorage.getItem("token") != null){
        this.loginState = true;
      }
    },
    methods: {
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      enterLogin(){
        this.changeSuspendType(0);
        this.changeSuspendState(true);
      },
      initTab(){
        const now = new Date();
        let month = now.getMonth();
        let day = now.getDate();
        let year = now.getFullYear();
        let nowTime = new Date(year,month,day,0);
        var timeTempList = [{ dateText: '今日开服', time: new Date(now), timeText: nowTime.getTime()}];
        this.serviceBean.time = nowTime.getTime();
        this.oldTimeStamp = nowTime.getTime();
        this.serviceBean.endTime = new Date(year,month,day,24).getTime() - 1000;
        var oldMonth = now.getMonth() + 1;
        var newMonth = oldMonth > 9 ? oldMonth : "0" + oldMonth;
        var oldDate = now.getDate();
        var newDate = oldDate > 9 ? oldDate : "0" + oldDate;
        this.dayText = newMonth +"-"+ newDate; 
        for(let i = 0;i < 4;i++) {
          now.setDate(now.getDate() + 1);
          var timeStamp = nowTime.setDate(nowTime.getDate()+1)
          oldMonth = now.getMonth() + 1;
          newMonth = oldMonth > 9 ? oldMonth : "0" + oldMonth;
          oldDate = now.getDate();
          newDate = oldDate > 9 ? oldDate : "0" + oldDate;
          timeTempList.push({ dateText: `${newMonth}-${newDate}`,timeText:timeStamp});
        }
        this.timeList = timeTempList;
      },
      searchGameEvent(){
        if(this.serviceBean.search != this.oldSearchName){
          this.oldSearchName = this.serviceBean.search;
          this.serviceBean.page = 1;
          this.queryAllOpenService();
        }
      },
      selectPage(value){  
        this.serviceBean.page = value;
        this.serviceList = this.tempServiceList.slice((value-1)*this.serviceBean.row,value*this.serviceBean.row);
      },
      queryAllOpenService(){
        this.$http.get(`/query_all_open_service`,{
          params:this.serviceBean
        }).then(res=>{
          if(res.data.code == 2000){
            this.serviceList = res.data.data.slice(0,this.serviceBean.row);
            this.tempServiceList = res.data.data;
            this.serviceTotal = res.data.total;
            if(this.serviceTotal > 0){
              this.showEmptyState = false;
            }else{
              this.showEmptyState = true;
            }
          }else{
            this.showEmptyState = true;
            this.serviceList = [];
            this.serviceTotal = 0;
          }
        });
      },
      gameLabelSelect(value){
        this.gameLabelDirector = this.serviceBean.classify = value;
        this.serviceBean.page = 1;
        this.queryAllOpenService();
      },
      gameTypeSelect(value) {
        this.gameTypeDirector = this.serviceBean.type = value;
        this.serviceBean.page = 1;
        this.queryAllOpenService();
      },
      gameLetterSelect(value) {
        this.gameLetterDirector = this.serviceBean.letter = value;
        this.serviceBean.page = 1;
        this.queryAllOpenService();
      },
      timeSelect(value,time){
        this.timeDirector = value; 
        this.serviceBean.time = this.oldTimeStamp = time;
        this.serviceBean.endTime = new Date(time).setHours(24)-1000;
        this.serviceBean.page = 1;
        this.queryAllOpenService();
      },
      enterGift(value){
        window.open(this.$router.resolve({name:'gift',params:{search:value}}).href,"_blank");
      },
      enterOfficial(tag,type){
        if(type == 1){
          window.open('/webOfficial/'+tag,'_blank');
        }else{
          window.open("/mobileOfficial/"+tag,'_blank');
        }
      },
    },   
    watch:{
      loginState(value){
        if(value){
          if(this.launchType == 1){
            window.open(this.launchHref,"_blank");
          }
        }
      },
    } 
  };
</script>
<style scoped src="@/assets/css/open_service.css"></style>
<style>
  .center-game-page .ivu-page-prev, .center-game-page .ivu-page-next{
    background: #fff;
  }
</style>
